/**
 * The filtering state is split into mutable and immutable state. Both may come pre-loaded from the server or the URL,
 * but only the mutable state should be altered during the lifetime of the app. The rest of the app relies on the
 * immutability of the immutable part of the filtering state.
 *
 * */


import {
    SET_IMMUTABLE_FILTERING_DATA,
    ADD_FILTER,
    REMOVE_FILTER,
    CALCULATE_AVAILABLE_OPTIONS,
    CALCULATE_FILTERED_ROW_KEYS,
} from "../actions/filtering";
import { removeActiveFilter } from "../../utils/data.transformations/activeFilter";
import { calculateFilteredDataKeys } from "../../utils/data.transformations/filteredDataKeys";
import { calculateAvailableOptions } from "../../utils/data.transformations/availableOptions";


export const initialImmutableFilteringState = {
    fields: [],
    options: {
        //  <field_name>: [
        //      <value1>,
        //      <value2>,
        //      ...
        //  ],
        //  ...
    },
};

export function immutableFiltering(state = initialImmutableFilteringState, action) {
    switch (action.type) {

        case SET_IMMUTABLE_FILTERING_DATA:
            return {
                ...state,
                fields: action.fields,
                options: action.options,
            };

        default:
            return state
    }
}


export const initialMutableFilteringState = {
    activeFilters: [],
    availableOptions: {},
    filteredRowKeys: [],
};

export function mutableFiltering(state = initialMutableFilteringState, action) {
    switch (action.type) {

        case ADD_FILTER:
            return {
                ...state,
                activeFilters: [ ...state.activeFilters, { field: action.field, value: action.value}]
            };

        case REMOVE_FILTER:

            return {
                ...state,
                activeFilters: removeActiveFilter(action.field, action.value, state.activeFilters)
            };

        case CALCULATE_FILTERED_ROW_KEYS:

            const filteredRowKeys = calculateFilteredDataKeys(
                action.initialRowKeys, action.rows, state.activeFilters
            );

            return {
                ...state,
                filteredRowKeys: filteredRowKeys,
            };

        case CALCULATE_AVAILABLE_OPTIONS:

            const availableOptions = calculateAvailableOptions(
                action.fields, action.initialOptions, state.activeFilters
            );

            return {
                ...state,
                availableOptions: availableOptions,
            };

        default:
            return state
    }
}
